module.exports = __webpack_public_path__ + "img/1.f0f8e5f9.png";